export const config = {
  url: {
    edgeNestUrl: 'https://api.tendril.dev:20050',
    syncUrl: 'https://api.tendril.dev:20030',
    contactsNestUrl: 'https://api.tendril.dev:20040',
    authUrl: 'https://api.tendril.dev:20060'
  },
  analytics: {
    measurementId: 'G-E9T3R33Y4Q',
  }
};
